import type { ErrorTranslations } from "./utils";

export default {
  not_found: {
    EN: "Registrar not found",
    RO: "Registratura nu a fost găsită",
  },
  invalid_element_identifiers: {
    EN: "Invalid element identifiers",
    RO: "Identificatorii elementelor sunt invalizi",
  },
  already_exists: {
    EN: "Registrar already exists",
    RO: "Registratura există deja",
  },
} satisfies ErrorTranslations;
